<template>
    <div class="conter">
        <!-- img -->
        <div class="top-img">
            <!-- 文字 -->
<!--            <div class="txt">Al-LiNK全联全控</div>-->
<!--            <div class="txttwo">懂你的智慧舒适家</div>-->
        </div>
        <!-- text -->
        <div class="text"></div>
        <!-- buttom-to -->
        <div @click="goto" class="buttom but-to">微信登录</div>
        <!-- buttom-close -->
        <!-- <div class="buttom but-close">关闭</div> -->
    </div>
</template>

<script>
import { getQrcodeUrl } from "@/js/member/mynews/index.js";
export default {
    data() {
        return {
            qrcodeUrl:'',
        };
    },
    created(){
        let data = {
            page:`pages/hvac/member/auth`,
            param: JSON.stringify({shareId:this.$route.query.shareId || ''}),
            type:3,
        }
        this.$store.commit("loadSkeleton", { bool: true, type: "home" });
        getQrcodeUrl(data).then(res=>{
            let qrcodeUrl = res.data.data.result.url;
            this.qrcodeUrl = qrcodeUrl;
            window.location.href = qrcodeUrl;
            this.$store.commit("loadSkeleton", { bool: false, type: "home" });
        })
    },
    methods: {
        goto() {
            window.location.href = this.qrcodeUrl;
        },
    },
};
</script>

<style lang="scss" scoped>
.conter {
    width: 100%;
    height: 100vh;
    background: #fff;
    text-align: center;
    .txt {
        position: relative;
        z-index: 1;
        text-align: center;
        color: #fff;
        font-size: 42px;
    }
    .txttwo {
        position: relative;
        z-index: 1;
        text-align: center;
        color: #a7e8c4;
    }
    .top-img {
        padding-top: 34px;
        //height: 676px;
        height: 986px;
        //background-image: url("../../../assets/images/phone_share.png");
        background-image: url("../../../assets/images/phone_share_v2.png");
        background-size: 100% 100%;
        position: relative;
    }
    .text {
        //padding: 78px;
        padding: 50px;
        font-size: 28px;
        font-weight: 400;
        color: #328444;
    }
    .buttom {
        width: 335px;
        height: 92px;
        line-height: 92px;
        border-radius: 46px;

        margin: auto;
        font-size: 32px;
        font-weight: 400;
        color: #ffffff;
    }
    .but-to {
        background: #328444;
    }
    .but-close {
        margin-top: 30px;
        background: #c6cbce;
    }
}
</style>
